import { Observable } from "rxjs";
import { WbmApiClient } from "@wbmason/api-client";
import { IItemIdentifier } from "../interfaces/IItemIdentifier.js";
import { IProductImage } from "../interfaces/IProductImage.js";
import { ICartItem } from "@wbmason/cart-service/interfaces/cartItem.js";
import { IIndicatorRequest, IIndicatorIcon } from "../interfaces/IIndicatorIcon.js";
import { IRelatedProduct } from "@wbmason/cart-service/interfaces/relatedProduct.js";
import { IPricedProduct } from "../interfaces/IPricedProduct.js";
import { setAccessToken } from "@wbmason/api-client/wbmApiClient.js";

export const ProductService = {
    getFeaturedProducts(itemIdentifier: IItemIdentifier): Observable<IPricedProduct[]> {
        const url = "/cart/api/FeaturedProduct";
        const config = { withCredentials: true };
        const observable: Observable<IPricedProduct[]> = getApiClient().post(url, itemIdentifier, config);
        return observable;
    },

    getIndicators(indicatorsRequest: IIndicatorRequest[]): Observable<IIndicatorIcon[]> {
        const config = { withCredentials: true };
        const url = "/productSearch/api/ItemIndicators";
        const observable: Observable<IIndicatorIcon[]> = getApiClient().post(url, indicatorsRequest, config);
        return observable;
    },

    getProductImages(productIds: number[]): Observable<IProductImage[]> {
        const url = "/productSearch/api/ProductImages";
        const config = { withCredentials: true };
        const observable: Observable<IProductImage[]> = getApiClient().post(url, productIds, config);
        return observable;
    },

    getOptionalChildProduct(optionalChildCartLine: ICartItem[]): Observable<IRelatedProduct[]> {
        const url = "/cart/api/OptionalChildProduct";
        const config = { withCredentials: true };
        const observable: Observable<IRelatedProduct[]> = getApiClient().post(url, optionalChildCartLine, config);
        return observable;
    },
    initAvailability() {
        return {
            alertLevel: 0,
            calloutMessage: '',
            deliveryMessage: '',
            itemId: '',
            stockMessage: '',
            unitId: '',
            wbTruckDelivery: false,
            requiresMessageDescriptions: false,
            estimatedDeliveryDate: '',
            estimatedDeliveryDateEndRange: '',
            doPreventAddToCart: false,
            preventPurchaseMessage: ''
        }
    },
};


const getBaseUrl = () => {
    if (typeof window === "undefined") {
        return "";
    }

    let baseUrl: string = window.process?.env?.APIM_BASE_URL
        ? window.process.env.APIM_BASE_URL
        : "";

    if (baseUrl.endsWith("/")) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1);
    }

    return baseUrl;
}


export const getApiClient = () => {
    let _lazyClient: WbmApiClient | undefined;
    if (!_lazyClient) {
        if (window.process.env.ACCESS_TOKEN) {
            setAccessToken(window.process.env.ACCESS_TOKEN)
        }
        const options = WbmApiClient.defaultOptions();
        options.baseUrl = getBaseUrl();

        _lazyClient = new WbmApiClient(options);
    }
    return _lazyClient;
}
